import { Pagination } from "@/modules/common/types/Pagination";

import api from "../api";
import { CreateLeadDto, ListAdminLeadsDto, UpdateLeadDto } from "../dto/admin-leads";
import { LeadListItemResponse, LeadResponse, LeadSummaryResponse } from "../response/admin-leads";

export const ADMIN_LEADS_ENDPOINTS = {
  LIST: "/v1/admin/leads",
  SUMMARY: "/v1/admin/leads/summary",
  DETAIL: (id: string) => `/v1/admin/leads/${id}`,
};

export const AdminLeadsService = {
  list: async (params: ListAdminLeadsDto = {}): Promise<Pagination<LeadListItemResponse>> => {
    const response = await api.get(ADMIN_LEADS_ENDPOINTS.LIST, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    });
    return response.data;
  },

  summary: async (): Promise<LeadSummaryResponse> => {
    const response = await api.get(ADMIN_LEADS_ENDPOINTS.SUMMARY);
    return response.data;
  },

  get: async (id: string): Promise<LeadResponse> => {
    const response = await api.get(ADMIN_LEADS_ENDPOINTS.DETAIL(id));
    return response.data;
  },

  create: async (data: CreateLeadDto): Promise<LeadListItemResponse> => {
    const response = await api.post(ADMIN_LEADS_ENDPOINTS.LIST, data);
    return response.data;
  },

  update: async (id: string, data: UpdateLeadDto): Promise<LeadListItemResponse> => {
    const response = await api.put(ADMIN_LEADS_ENDPOINTS.DETAIL(id), data);
    return response.data;
  },
};
